import { useQuery } from "@tanstack/react-query";

import { useDataSource } from "@/adapters/data-source";

/**
 * A count beside a sidebar entry that has work waiting (#702).
 *
 * Only Orders > Escalations has one today: the number of `new` escalations,
 * the ones not yet sent to the courier. It reads the same counts the screen's
 * tabs do, so the two cannot disagree, and says nothing at all when there are
 * none or the counts cannot be read.
 */
function EscalationCount() {
  const data = useDataSource();
  const counts = useQuery({
    queryKey: ["escalations", "counts"],
    queryFn: () => data.escalations.counts(),
    refetchInterval: 60_000,
    retry: false,
  });
  const waiting = counts.data?.new ?? 0;
  if (waiting === 0) return null;
  return (
    <span
      className="bg-primary text-primary-foreground ml-auto rounded-full px-1.5 text-xs tabular-nums"
      aria-label={`${String(waiting)} new`}
    >
      {waiting}
    </span>
  );
}

export function SectionNavCount({
  moduleId,
  sectionId,
}: {
  moduleId: string;
  sectionId: string;
}) {
  if (moduleId === "orders" && sectionId === "escalations") {
    return <EscalationCount />;
  }
  return null;
}
